import { styleHelpers } from '@nocowanie/core/helpers';

export const globalNocowanieStyles = {
    img: { filter: 'contrast(1.05) saturate(1.15)' },
    '.gm-style img': { filter: 'none' },

    // SalesManago banner - ensure iframe is clickable above Chakra UI overlays/drawers
    '#bhr-iframe-consent-form': {
        pointerEvents: 'auto',
    },
};

export const globalNocowanieStylesRaw = styleHelpers.convertToRawCss(globalNocowanieStyles);
